/* eslint-disable jsx-a11y/no-static-element-interactions */
import { toNumber } from 'lodash-es';
import React from 'react';
import Button from '../../components/ComponentsV1/Button';
import { Minus } from 'lucide-react';
import { Plus } from 'lucide-react';

const AddButton = (props) => {
  const {
    handleIncrease,
    handleDecrease,
    count = 0,
    showCustomInput = false,
    setCount = () => {},
    increaseDisabled = false,
    decreaseDisabled = false,
    isCopilotView = false,
  } = props;

  const inputOnChangeHandler = (e) => {
    let input = e.target;
    input.addEventListener('mousewheel', function () {
      this.blur();
    });
    setCount(toNumber(e.target.value));
  };

  const inputOnFocusHandler = (e) => {
    const targetElement = e.target;
    targetElement.placeholder = 'Enter Unit';
    targetElement.classList.replace(
      'placeholder:tw-text-green-700',
      'placeholder:tw-text-grey-300',
    );
  };

  const inputOnBlurHandler = (e) => {
    const targetElement = e.target;
    targetElement.placeholder = 'ADD';
    targetElement.classList.replace(
      'placeholder:tw-text-grey-300',
      'placeholder:tw-text-green-700',
    );
  };

  if (showCustomInput)
    return (
      <div className='tw-flex tw-w-[8.2rem] tw-h-[3.2rem] tw-items-center tw-justify-center'>
        <input
          type='number'
          className='tw-w-full tw-h-full tw-bg-grey-100 tw-outline-none tw-border-solid tw-border-green-700 tw-rounded-lg tw-text-green-700 tw-font-medium tw-text-300 tw-flex tw-items-center tw-justify-center tw-text-center placeholder:tw-text-green-700 placeholder:tw-text-100 tw-cursor-pointer'
          onChange={inputOnChangeHandler}
          value={count ? count : ''}
          placeholder='ADD'
          onFocus={inputOnFocusHandler}
          onBlur={inputOnBlurHandler}
        />
      </div>
    );

  return (
    <Button
      size='small'
      title={
        <div
          className={`tw-flex tw-items-center ${
            isCopilotView
              ? 'tw-w-28 tw-justify-center tw-gap-[4px]'
              : 'tw-w-full'
          }`}
        >
          <span
            className={`tw-h-full tw-flex tw-items-center tw-justify-center ${
              decreaseDisabled ? 'tw-cursor-not-allowed' : 'tw-cursor-pointer'
            }`}
            onClick={decreaseDisabled ? () => {} : handleDecrease}
          >
            <Minus size={17} className='tw-text-white' />
          </span>
          <div className='tw-h-full tw-text-[1.5rem] tw-mx-3 tw-text-white tw-font-medium tw-flex tw-items-center tw-justify-center tw-text-center '>
            {count}
          </div>
          <span
            className={`tw-h-full tw-flex tw-items-center tw-justify-center ${
              increaseDisabled ? 'tw-cursor-not-allowed' : 'tw-cursor-pointer'
            }`}
            onClick={increaseDisabled ? () => {} : handleIncrease}
          >
            <Plus size={17} className='tw-text-white' />
          </span>
        </div>
      }
    />
  );
};

export const AddItemButtonCustom = (props) => {
  const { count, handleIncrease, disabled, showCustomInput } = props;
  if (!count && !showCustomInput)
    return (
      <Button
        className={!disabled ? '!tw-bg-white' : ''}
        type={disabled ? 'primary' : 'outline'}
        title={'ADD'}
        onClick={disabled ? () => {} : handleIncrease}
        disabled={disabled}
      />
    );
  return <AddButton {...props} />;
};
